import { memo, useEffect, useState } from 'react'
import { ProjectDetailManagementTab } from './components/projectDetailManagementTab/projectDetailManagementTab'
import { Route, Routes, Navigate, useParams } from 'react-router-dom'
import { ProjectDetailManagementTabs } from 'enums/app'
import { ProjectDetailManagementAdvancedSetting } from './components/projectDetailManagementAdvancedSetting/projectDetailManagementAdvancedSetting'
import { ProjectDetailManagementEventKindList } from './components/projectDetailManagementEventKindList/projectDetailManagementEventKindList'
import { ProjectDetailManagementTaskKindList } from './components/projectDetailManagementTaskKindList/projectDetailManagementTaskKindList'
import { ProjectDetailManagementTaskCategoryList } from './components/projectDetailManagementTaskCategoryList/projectDetailManagementTaskCategoryList'
import { ProjectDetailManagementTaskStateList } from './components/projectDetailManagementTaskStateList/projectDetailManagementTaskStateList'
import { ProjectDetailManagementTaskTemplateList } from './components/projectDetailManagementTaskTemplateList/projectDetailManagementTaskTemplateList'
import { useProjectDetailManagementPanel } from './useProjectDetailManagementPanel'
import { useAppSelector } from 'states/hooks'
import { GetProjectRequest } from '@crew/apis/project/models/getProject/request'
import { useGetProjectQuery } from '@crew/apis/project/projectApis'
import { skipToken } from '@reduxjs/toolkit/query'
import { useProjectPermissions } from '@crew/hooks'
import { EntityType } from '@crew/enums/domain'

export const ProjectDetailManagementPanel = memo(() => {
  const { projectDetailManagementPanelContext } =
    useProjectDetailManagementPanel()

  const { projectId } = useParams()
  const loggedInUser = useAppSelector((state) => state.app.loggedInUser)
  const [isJoinedProject, setIsJoinedProject] = useState<boolean>(false)

  // プロジェクト詳細を取得する
  // 三項演算子になっていて少し見づらいが、内部のパラメータがundefinedを受け付けないため三項演算子を使用している
  const getProjectParam: GetProjectRequest | undefined = projectId
    ? {
        projectId,
      }
    : undefined
  const { data: getProjectResult } = useGetProjectQuery(
    getProjectParam ?? skipToken
  )

  // Update selected project & joined project state
  useEffect(() => {
    if (projectId && loggedInUser && getProjectResult?.project) {
      setIsJoinedProject(
        getProjectResult?.project.projectMembers.some(
          (projectMember) => loggedInUser.id === projectMember.id
        ) || loggedInUser.id === getProjectResult?.project.ownerUser.id
      )
    }
  }, [projectId, getProjectResult?.project, loggedInUser])

  // プロジェクト件名（LocalState）
  const [projectSubject, setProjectSubject] = useState<string>(
    getProjectResult?.project?.subject ?? ''
  )
  const { hasPrjProjectSettingEditPermission } = useProjectPermissions(
    EntityType.Project,
    projectId
  )

  return hasPrjProjectSettingEditPermission ? (
    <projectDetailManagementPanelContext.Provider
      value={{
        projectSubject,
        setProjectSubject,
      }}
    >
      {isJoinedProject ? (
        <div className="flex flex-row p-2.5 gap-2 grow min-h-0">
          <ProjectDetailManagementTab />

          <div className="grow min-h-0 w-full flex flex-col">
            <Routes>
              <Route
                index
                element={
                  <Navigate
                    to={ProjectDetailManagementTabs.AdvancedSetting.value}
                    replace
                  />
                }
              />
              <Route
                path={ProjectDetailManagementTabs.AdvancedSetting.value}
                element={<ProjectDetailManagementAdvancedSetting />}
              />
              <Route
                path={ProjectDetailManagementTabs.EventKind.value}
                element={<ProjectDetailManagementEventKindList />}
              />
              <Route
                path={ProjectDetailManagementTabs.TaskKind.value}
                element={<ProjectDetailManagementTaskKindList />}
              />
              <Route
                path={ProjectDetailManagementTabs.TaskCategory.value}
                element={<ProjectDetailManagementTaskCategoryList />}
              />
              <Route
                path={ProjectDetailManagementTabs.TaskStatus.value}
                element={<ProjectDetailManagementTaskStateList />}
              />
              <Route
                path={ProjectDetailManagementTabs.TaskTemplate.value}
                element={<ProjectDetailManagementTaskTemplateList />}
              />
            </Routes>
          </div>
        </div>
      ) : null}
    </projectDetailManagementPanelContext.Provider>
  ) : null
})
